<template>
  <div class="order-detail">
    <div class="page-panel">
      <div class="header">
        <div class="title">{{ $t('order_detail_gdbh') }}：{{ isWorkOrder ? info.workOrderCode : info.caseOrderCode }}</div>
      </div>
      <div class="blue-line"></div>
      <div class="status-content">
        <div class="status">
          <div class="label">{{ $t('order_detail_gdzt') }}：</div>
          <div class="value">{{ isWorkOrder ? getDicValue('asm_work_order_state', info.workOrderState) : getDicValue('asm_case_order_state', info.caseOrderState) }}</div>
        </div>
        <div class="btn-content">
          <div class="btn" @click="onClose" v-if="closeOrderVisible(this.info)">{{ $t('order_detail_qu_xiao_gong_dan') }}</div>
        </div>
      </div>
      <div class="process-content">
        <t-step v-model="step" :list="stepList"></t-step>
      </div>
      <div class="info-content">
        <div class="l">
          <div class="gray-content group-content">
            <div class="info">
              <div class="header">
                <div class="label">{{ pageType === 'maintain' ? $t('order_detail_bao_yang_xin_xi') : $t('order_detail_gu_zhang_xin_xi') }}</div>
                <div class="tap" @click="faultInfoIsOpen = !faultInfoIsOpen">
                  <span class="text">{{ faultInfoIsOpen ? $t('order_detail_shou_qi') : $t('order_detail_zhan_kai') }}</span>
                  <i class="icon icon-zhankai" :class="{ rotate: faultInfoIsOpen }"></i>
                </div>
              </div>
              <div class="detail-list" v-show="faultInfoIsOpen">
                <div class="item">
                  <div class="title">{{ pageType === 'maintain' ? $t('order_detail_bao_yang_she_bei') : $t('order_detail_gu_zhang_she_bei') }}</div>
                  <div class="item-content">
                    <div class="device-info" @click="toDeviceDetail" :class="{ cursor: !prePageIsDeviceDetail }">
                      <div class="device-img">
                        <el-image style="width: 100%; height: 100%" :src="productMainImg" :preview-src-list="[productMainImg]" fit="cover">
                          <div class="image-error" slot="error">
                            <i class="icon icon-24gl-pictureSplit"></i>
                          </div>
                        </el-image>
                      </div>
                      <div class="arrow-content" v-if="!prePageIsDeviceDetail">
                        <i class="icon icon-you"></i>
                      </div>
                      <div class="device-params">
                        <div class="body-num">{{ info.bodyNum }}</div>
                        <div class="tag-list">
                          <span class="product-code">{{ info.productCode }}</span>
                          <span class="tag" v-if="info.floorName">{{ info.floorName }}</span>
                          <span class="tag" v-if="info.siteName">{{ info.siteName || '-' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="title">{{ pageType === 'maintain' ? $t('order_detail_byms') : $t('order_detail_gzms') }}</div>
                  <div class="item-content">
                    <div class="fault-info">
                      <div class="fault-desc">{{ info.caseOrderDesc || $t('order_detail_zan_wu_miao_shu') }}</div>
                      <div class="fault-img" v-if="faultImgList.length">
                        <div class="img-item" v-for="(item, index) in faultImgList" :key="index">
                          <el-image style="width: 100%; height: 100%" :src="getAttachUrl(item)" :preview-src-list="[getAttachUrl(item)]" fit="cover"></el-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gray-content group-content" v-if="pageType === 'maintain'">
            <div class="info">
              <div class="header">
                <div class="label">{{ $t('order_detail_byxm') }}</div>
                <div class="tap" @click="maintainInfoIsOpen = !maintainInfoIsOpen">
                  <span class="text">{{ maintainInfoIsOpen ? $t('order_detail_shou_qi_1') : $t('order_detail_zhan_kai_1') }}</span>
                  <i class="icon icon-zhankai" :class="{ rotate: maintainInfoIsOpen }"></i>
                </div>
              </div>
              <div class="detail-list" v-show="maintainInfoIsOpen">
                <div class="item">
                  <el-tabs v-model="maintainType">
                    <el-tab-pane name="maintain" :label="$t('order_detail_bao_yang_xiang') + ' (' + componentList.length + ')'"></el-tab-pane>
                    <el-tab-pane name="check" :label="$t('order_detail_jian_cha_xiang') + ' (' + itemList.length + ')'"></el-tab-pane>
                  </el-tabs>
                  <div class="maintain-list" v-if="maintainType === 'maintain'">
                    <el-collapse v-model="maintainComponentCode" accordion>
                      <el-collapse-item :title="index + 1 + '.' + '\xa0\xa0\xa0\xa0' + item.componentName" v-for="(item, index) in componentList" :key="index" :name="item.upkeepResultId">
                        <div class="maintain-item">
                          <div class="maintain-item__title">{{ $t('order_detail_bao_yang_qian') }}</div>
                          <div class="img-list" v-if="item.beforeimg && item.beforeimg.length">
                            <div class="img-item" v-for="(img, i) in item.beforeimg" :key="i">
                              <el-image fit="cover" :src="img" :preview-src-list="[img]"></el-image>
                            </div>
                          </div>
                          <div v-else class="no-img">无</div>
                        </div>
                        <div class="maintain-item">
                          <div class="maintain-item__title">{{ $t('order_detail_bao_yang_hou') }}</div>
                          <div class="img-list" v-if="item.afterimg && item.afterimg.length">
                            <div class="img-item" v-for="(img, i) in item.afterimg" :key="i">
                              <el-image fit="cover" :src="img" :preview-src-list="[img]"></el-image>
                            </div>
                          </div>
                          <div v-else class="no-img">无</div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                  <div class="check-list" v-else>
                    <div class="check-item" v-for="(item, index) in itemList" :key="index">
                      <div class="checked-content" :class="item.isChecked ? 'checked' : ''"></div>
                      <div class="item-text">{{ index + 1 }}.&nbsp;&nbsp;&nbsp;&nbsp;{{ item.itemName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gray-content group-content">
            <div class="info">
              <div class="header">
                <div class="label">{{ pageType === 'maintain' ? $t('order_detail_bao_yang_jie_guo') : $t('order_detail_wei_xiu_jie_guo') }}</div>
                <div class="tap" @click="repairInfoIsOpen = !repairInfoIsOpen">
                  <span class="text">{{ repairInfoIsOpen ? $t('order_detail_shou_qi_2') : $t('order_detail_zhan_kai_2') }}</span>
                  <i class="icon icon-zhankai" :class="{ rotate: repairInfoIsOpen }"></i>
                </div>
              </div>
              <div class="detail-list" v-show="repairInfoIsOpen">
                <!-- 保养工单没有维修反馈 -->
                <div class="item" v-if="pageType !== 'maintain'">
                  <div class="title">{{ $t('order_detail_wei_xiu_fan_kui') }}</div>
                  <div class="item-content">
                    <div class="fault-info">
                      <div class="fault-desc">{{ techInfo.customerFeedback || $t('order_detail_zan_wu_miao_shu_1') }}</div>
                      <div class="fault-img" v-if="repairImgList.length">
                        <div class="img-item" v-for="(item, index) in repairImgList" :key="index">
                          <el-image style="width: 100%; height: 100%" :src="getAttachUrl(item)" :preview-src-list="[getAttachUrl(item)]" fit="cover"></el-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="title">{{ $t('order_detail_ghlj') }}</div>
                  <div class="item-content">
                    <div class="part-list" v-if="partList.length">
                      <div class="part-item" v-for="(item, index) in partList" :key="index">
                        <div class="part-img">
                          <el-image style="width: 100%; height: 100%" :src="item.partImg" :preview-src-list="[item.partImg]" fit="cover">
                            <div class="image-error" slot="error">
                              <i class="icon icon-24gl-pictureSplit"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="part-num">x{{ item.replaceNum }}</div>
                        <div class="part-info">
                          <div class="part-name">{{ item.partName }} - {{ item.partCode }}</div>
                          <div class="part-params">{{ item.partSpec }}</div>
                        </div>
                      </div>
                    </div>
                    <empty-tips v-else></empty-tips>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="r">
          <div class="blue-content group-content" v-if="info.technicianName">
            <div class="repairman">
              <div class="title">{{ $t('order_detail_wei_xiu_shi') }}</div>
              <div class="group">
                <div class="info">
                  <div class="name">{{ info.technicianName || '-' }}</div>
                  <div class="company">{{ info.technicianOrgName || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="blue-content group-content">
            <div class="order-info info">
              <div class="header">
                <div class="label">{{ $t('order_detail_gong_dan_xin_xi') }}</div>
                <div class="tap" @click="orderInfoIsOpen = !orderInfoIsOpen">
                  <span class="text">{{ orderInfoIsOpen ? $t('order_detail_shou_qi_3') : $t('order_detail_zhan_kai_3') }}</span>
                  <i class="icon icon-zhankai" :class="{ rotate: orderInfoIsOpen }"></i>
                </div>
              </div>
              <ul class="list" v-show="orderInfoIsOpen">
                <li class="item">
                  <div class="label">{{ $t('order_detail_chuang_jian_ren') }}：</div>
                  <div class="value">{{ info.creator || '-' }}</div>
                </li>
                <li class="item">
                  <div class="label">{{ $t('order_detail_cjsj') }}：</div>
                  <div class="value">{{ momentAmPm($momentLocal(info.gmtCreate) || '-') }}</div>
                </li>
                <li class="item" v-if="isCoJv && showSubsidiary">
                  <div class="label">{{ $t('order_detail_zu_lin_fang') }}：</div>
                  <div class="value">{{ info.customerName || '-' }}</div>
                </li>
                <li class="item">
                  <div class="label">{{ $t('order_detail_xiang_mu') }}：</div>
                  <div class="value">{{ info.locationName || '-' }}</div>
                </li>
                <li class="item">
                  <div class="label">{{ $t('order_detail_lian_xi_ren') }}：</div>
                  <div class="value">{{ info.contactName || '-' }} {{ formatPhone(info.contactPhone) || '-' }}</div>
                </li>
                <li class="item">
                  <div class="label">{{ $t('order_detail_fu_wu_di_zhi') }}：</div>
                  <div class="value">{{ info.useAddress || '-' }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="blue-content group-content">
            <div class="info">
              <div class="header">
                <div class="label">{{ $t('order_detail_gdgz') }}</div>
                <div class="tap" @click="orderTrackIsOpen = !orderTrackIsOpen">
                  <span class="text">{{ orderTrackIsOpen ? $t('order_detail_shou_qi_4') : $t('order_detail_zhan_kai_4') }}</span>
                  <i class="icon icon-zhankai" :class="{ rotate: orderTrackIsOpen }"></i>
                </div>
              </div>
              <div class="track-list" v-show="orderTrackIsOpen">
                <div class="item" v-for="(item, index) in orderTrackList" :key="index">
                  <div class="circle">
                    <div class="inner"></div>
                  </div>
                  <div class="fl1">{{ item.statusView }}</div>
                  <div class="fl2">{{ item.desc }}</div>
                  <div class="fl3">{{ momentAmPm($momentLocal(item.date)) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <acceptance-comments-dialog v-if="acceptanceCommentsVisible" @close="acceptanceCommentsVisible = false" :model="acceptanceCommentsModel" @success="onSuccess"></acceptance-comments-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import acceptanceCommentsDialog from './children/close_order_dialog.vue';
import mixins from './children/mixins';

// i18n-lang-component
// order_detail_gdbh: 工单编号// order_detail_gdzt: 工单状态// order_detail_qu_xiao_gong_dan: 取消工单// order_detail_bao_yang_xin_xi: 保养信息// order_detail_gu_zhang_xin_xi: 故障信息// order_detail_shou_qi: 收起// order_detail_zhan_kai: 展开// order_detail_bao_yang_she_bei: 保养设备// order_detail_gu_zhang_she_bei: 故障设备// order_detail_byms: 保养描述// order_detail_gzms: 故障描述// order_detail_zan_wu_miao_shu: 暂无描述// order_detail_byxm: 保养项目// order_detail_shou_qi_1: 收起// order_detail_zhan_kai_1: 展开// order_detail_bao_yang_qian: 保养前// order_detail_bao_yang_hou: 保养后// order_detail_bao_yang_jie_guo: 保养结果// order_detail_wei_xiu_jie_guo: 维修结果// order_detail_shou_qi_2: 收起// order_detail_zhan_kai_2: 展开// order_detail_wei_xiu_fan_kui: 维修反馈// order_detail_zan_wu_miao_shu_1: 暂无描述// order_detail_ghlj: 更换零件// order_detail_wei_xiu_shi: 维修师// order_detail_gong_dan_xin_xi: 工单信息// order_detail_shou_qi_3: 收起// order_detail_zhan_kai_3: 展开// order_detail_chuang_jian_ren: 创建人// order_detail_cjsj: 创建时间// order_detail_zu_lin_fang: 租赁方// order_detail_xiang_mu: 项目// order_detail_lian_xi_ren: 联系人// order_detail_fu_wu_di_zhi: 服务地址// order_detail_gdgz: 工单跟踪// order_detail_shou_qi_4: 收起// order_detail_zhan_kai_4: 展开// order_detail_bao_yang_xiang: 保养项// order_detail_jian_cha_xiang: 检查项// order_detail_guan_bi_gong_dan: 关闭工单// order_detail_dai_jie_dan: 待接单// order_detail_yi_jie_dan: 已接单// order_detail_shang_men_zhong: 上门中// order_detail_yi_dao_da: 已到达// order_detail_yi_jie_jue: 已解决// order_detail_yi_jie_jue_1: 已解决// order_detail_yi_wan_cheng: 已完成// order_detail_wei_jie_jue: 未解决// order_detail_yi_guan_bi: 已关闭// order_detail_yi_jie_jue_2: 已解决

export default {
  name: 'orderDetail',
  mixins: [mixins],
  components: {
    tStep,
    acceptanceCommentsDialog,
  },
  props: {},
  data() {
    return {
      orderInfoIsOpen: true,
      orderTrackIsOpen: true,
      faultInfoIsOpen: true,
      repairInfoIsOpen: true,
      maintainInfoIsOpen: true,
      caseOrderId: '',
      queryWorkOrderId: '',
      info: {},
      step: '1',
      stepList: [],
      trackList: [],
      // 维修反馈图片
      repairImgList: [],
      // 故障图片
      faultImgList: [],
      productMainImg: '',
      partList: [],

      acceptanceCommentsVisible: false,
      acceptanceCommentsModel: {},

      techInfo: {},
      // 页面类型： repair - 维修  maintain - 保养
      pageType: 'repair',
      componentList: [],
      itemList: [],
      // maintain - 保养项  check - 检查项
      maintainType: 'maintain',
      maintainComponentCode: '',
      // 是否为工单（非case 工单）
      isWorkOrder: false,
      // 上个页面是否为设备详情
      prePageIsDeviceDetail: false,
    };
  },
  computed: {
    orderTrackList() {
      const list = [...this.trackList];
      const ret = list.map(item => ({
        statusView: this.dicValueName.asm_case_order_state[item.caseOrderState],
        desc: item.langStateDescView,
        date: item.gmtCreate,
      }));

      return ret;
    },
    orderDeviceId() {
      return this.info.orderDeviceId;
    },
    orderTechnicianId() {
      return this.info.orderTechnicianId;
    },
    workOrderId() {
      return this.info.workOrderId;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 根据工单号 caseOrderCode || workOrderCode  修正pageType
    // 于是不需要通过pageQuery传入pageType了
    fixPageType() {
      const info = this.info;
      const code = info.caseOrderCode || info.workOrderCode;
      // BY: 保养单    WX：维修单
      const pattern = /^BY/;
      if (pattern.test(code)) {
        this.pageType = 'maintain';
      } else {
        this.pageType = 'repair';
      }
    },
    // 电话中间4位用*代替
    formatPhone(num) {
      if (!num) {
        return num;
      }
      const numStr = `${num}`;
      const arr = [...numStr];
      arr.splice(3, 4, '***');
      return arr.join('');
    },
    toDeviceDetail() {
      if (this.prePageIsDeviceDetail) {
        return;
      }
      const { bodyNum, deviceId } = this.info;
      const { caseOrderId, caseOrderCode } = this.$route.query;
      const url = `/service/order/detail/accountDeviceDetail?bodyNum=${bodyNum}&deviceId=${deviceId}&caseOrderId=${caseOrderId}&caseOrderCode=${caseOrderCode}`;
      this.jump(url);
    },
    // 关闭
    onClose() {
      this.acceptanceCommentsModel = {
        title: this.$t('order_detail_guan_bi_gong_dan'),
        data: this.info,
      };
      this.acceptanceCommentsVisible = true;
    },
    // 获取更换零件列表
    async getPartList() {
      const { orderTechnicianId, workOrderId } = this.info;
      if (orderTechnicianId && workOrderId) {
        const res = await this.$getJSON(apis.workOrderPartList, {
          orderTechnicianId: this.info.orderTechnicianId,
          workOrderId: this.info.workOrderId,
        });
        const list = res.data || [];
        list.forEach((item) => {
          item.partImg = '';
          if (item.afterReplaceImg) {
            this.$getJSON(apis.attachList, {
              attachIds: item.afterReplaceImg,
            }).then((imgRes) => {
              const arr = imgRes.data.map(f => this.getAttachUrl(f));
              if (arr && arr.length) {
                item.partImg = arr[0];
              }
            });
          }
        });
        this.partList = list;
      }
    },
    // 获取维修反馈图片
    async getRepairImgList() {
      if (!this.techInfo.workOrderDeviceId) {
        return;
      }
      const list = await this.$getFileList({ bizId: this.techInfo.workOrderDeviceId, bizType: 'asm.feedback.customer' });
      this.repairImgList = list;
    },
    // 获取故障图片
    async getFaultImgList() {
      if (!this.caseOrderId) {
        return;
      }
      const list = await this.$getFileList({ bizId: this.caseOrderId, bizType: 'asm.service.request' });
      this.faultImgList = list;
    },
    // 订单跟踪
    async getTrackList() {
      const res = await this.$getJSON(apis.caseOrderStateList, { caseOrderId: this.caseOrderId });
      this.trackList = res.data;
    },
    getCurStep(caseOrderState) {
      /*
      待接单：20，30，40
      已接单：50
      上门中：60
      已到达：70
      已解决：90，100    未解决：91    已关闭：120
      */
      if ([20, 30, 40].includes(caseOrderState)) {
        return '1';
      }
      if ([50].includes(caseOrderState)) {
        return '2';
      }
      if ([60].includes(caseOrderState)) {
        return '3';
      }
      if ([70].includes(caseOrderState)) {
        return '4';
      }
      if ([90, 91, 100, 120].includes(caseOrderState)) {
        return '5';
      }
      return '';
    },
    getStepList() {
      const info = this.info;
      const trackList = this.trackList;
      const stateKey = this.isWorkOrder ? 'workOrderState' : 'caseOrderState';
      const config = [
        {
          label: this.$t('order_detail_dai_jie_dan'),
          status: [20, 30, 40],
        },
        {
          label: this.$t('order_detail_yi_jie_dan'),
          status: [50],
        },
        {
          label: this.$t('order_detail_shang_men_zhong'),
          status: [60],
        },
        {
          label: this.$t('order_detail_yi_dao_da'),
          status: [70],
        },
        {
          label: this.$t('order_detail_yi_jie_jue'),
          status: [90, 91, 100, 120],
        },
      ];
      const list = config.map((item, index) => {
        const obj = trackList.find(i => item.status.includes(i[stateKey]));
        const ret = {
          label: index + 1,
          value: String(index + 1),
          title: item.label,
        };
        if (obj) {
          ret.subTitle = this.$momentLocal(obj.gmtCreate);
        }
        return ret;
      });

      /*
      待接单：20，30，40 gmtCreate
      已接单：50 transferorTime
      上门中：60
      已到达：70
      已解决：90， 已-完-成：100 finishTime    未解决：91    已关闭：120
      */
      const lastNode = list[list.length - 1];
      if ([90].includes(info[stateKey])) {
        lastNode.title = this.$t('order_detail_yi_jie_jue_1');
      } else if ([100].includes(info[stateKey])) {
        lastNode.title = this.$t('order_detail_yi_wan_cheng');
      } else if ([91].includes(info[stateKey])) {
        lastNode.title = this.$t('order_detail_wei_jie_jue');
      } else if ([120].includes(info[stateKey])) {
        lastNode.title = this.$t('order_detail_yi_guan_bi');
      } else {
        lastNode.title = this.$t('order_detail_yi_jie_jue_2');
      }
      const ret = [...list];

      return ret;
    },
    // 过滤空值
    filterArr(arr, key) {
      arr.forEach((item) => {
        item[key] = item[key].filter(i => i);
      });
      return arr;
    },
    getComponentList() {
      if (!this.orderTechnicianId) {
        return;
      }
      this.$getJSON(apis.workOrderUpkeepResultComponentList, {
        orderDeviceId: this.orderDeviceId,
        orderTechnicianId: this.orderTechnicianId,
      }).then((res) => {
        const list = res.data || [];
        if (list) {
          this.formatAttachList(list, 'upkeepResultId', 'asm.maintenance.before', 'beforeimg', 'Array')
            .then(result => this.formatAttachList(this.filterArr(result, 'beforeimg'), 'upkeepResultId', 'asm.maintenance.after', 'afterimg', 'Array'))
            .then((result) => {
              this.componentList = this.filterArr(result, 'afterimg') || [];
              if (this.componentList.length) {
                const imgItem = this.componentList.find(item => (item.beforeimg && item.beforeimg.length) || (item.afterImg && item.afterImg.length));
                // 如果有维修反馈的图片，才展开
                if (imgItem) {
                  this.maintainComponentCode = imgItem.upkeepResultId;
                }
              }
            });
        }
      });
    },
    getItemList() {
      if (this.workOrderId) {
        // 工单
        this.$getJSON(apis.workOrderItemList, {
          workOrderId: this.workOrderId,
        }).then((res) => {
          const list = res.data || [];
          if (list) {
            this.formatAttachList(list, 'itemId', 'asm.service.item.icon', 'attachPath', 'Array').then((result) => {
              this.itemList = this.filterArr(result, 'attachPath') || [];
            });
          }
        });
      } else {
        // 案例
        this.$getJSON(apis.caseOrderItemList, {
          caseOrderId: this.caseOrderId,
          // workOrderId: '551587061861699590',
        }).then((res) => {
          const list = res.data || [];
          if (list) {
            this.formatAttachList(list, 'itemId', 'asm.service.item.icon', 'attachPath', 'Array').then((result) => {
              this.itemList = this.filterArr(result, 'attachPath') || [];
            });
          }
        });
      }
    },
    async init() {
      await Promise.all([this.getTrackList(), this.getFaultImgList()]);

      await this.getInfo();
      this.fixPageType();
      await this.getTechInfo();
      await this.getProductMainImg();
      await this.getRepairImgList();
      await this.getPartList();
      this.getComponentList();
      this.getItemList();
    },
    async getInfo() {
      const url = this.isWorkOrder ? `${apis.WorkOrderDetail}/${this.queryWorkOrderId}` : `${apis.caseOrderInfo}/${this.caseOrderId}`;
      const res = await this.$getJSON(url);
      this.info = res.data;
      this.step = this.getCurStep(this.isWorkOrder ? this.info.workOrderState : this.info.caseOrderState);
      this.stepList = this.getStepList();
      return res;
    },
    async getProductMainImg() {
      if (!this.info.productCodeId) {
        return;
      }
      this.$getFileList({ bizId: this.info.productCodeId, bizType: 'dms.product.icon' }).then((list) => {
        if (list && list.length) {
          this.productMainImg = this.getAttachUrl(list[0]);
        }
      });
    },
    // 获取维修师信息
    async getTechInfo() {
      const { workOrderId, orderTechnicianId } = this.info;
      if (workOrderId && orderTechnicianId) {
        const res = await this.$getJSON('/asm/workOrderDevice/info', {
          workOrderId,
          orderTechnicianId,
        });

        this.techInfo = res.data || {};

        return res;
      }
      return null;
    },
    onSuccess() {
      this.init();
    },
  },
  created() {},
  mounted() {
    this.mergeLanguage(null, 'portal_orderDetail');
    const pageType = this.$route.query.pageType;
    this.caseOrderId = this.$route.query.caseOrderId;
    this.queryWorkOrderId = this.$route.query.workOrderId;
    this.isWorkOrder = this.$route.query.isWorkOrder === 'true';
    this.prePageIsDeviceDetail = this.$route.query.prePageIsDeviceDetail === 'true';
    if (pageType) {
      this.pageType = pageType;
    }
    this.getDictionaryValueName('asm_case_order_state', () => {
      this.init();
    });
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  padding: 24px;

  .cursor {
    cursor: pointer;
  }

  .no-img {
    font-size: 14px;
    line-height: 30px;
  }

  /deep/ .image-error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      font-size: 30px;
    }
  }

  .page-panel {
    background: #fff;
    border-radius: 16px;
    padding: 24px;

    > .header {
      height: 88px;
      line-height: 88px;
      .title {
        color: #1a1a1a;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .blue-line {
      width: 100%;
      height: 0px;
      border: 1px solid;
      border-image-source: linear-gradient(90deg, rgba(0, 160, 217, 0.05) 0%, rgba(0, 160, 217, 0.16) 49.52%, rgba(0, 160, 217, 0.05) 99.04%);
    }

    .status-content {
      width: 100%;
      height: 88px;
      line-height: 88px;
      .status {
        float: left;
        .label {
          float: left;
          color: #4d4d4d;
          font-size: 16px;
          font-weight: bold;
        }
        .value {
          float: left;
          color: #00a0d9;
          font-size: 16px;
          padding-left: 32px;
          position: relative;
          font-weight: bold;
          &::before {
            content: ' ';
            width: 8px;
            height: 8px;
            border-radius: 100%;
            background: #00a0d9;
            left: 16px;
            top: 0;
            bottom: 0;
            margin: auto;
            position: absolute;
          }
        }
      }
      .btn-content {
        float: right;
        .btn {
          display: inline-block;
          text-align: center;
          height: 40px;
          min-width: 60px;
          line-height: 40px;
          padding-left: 16px;
          padding-right: 16px;
          border-radius: 20px;
          font-size: 14px;
          color: #202945;
          box-shadow: 0 0 0 1.5px #202945 inset;
          font-weight: bold;
        }
      }
    }

    > .process-content {
      height: 124px;
      width: 100%;
      background: #f8f8f8;
      padding-top: 32px;
    }

    > .info-content {
      display: flex;
      padding-top: 24px;

      .blue-content {
        border: 1px solid rgba(0, 160, 217, 0.2);
      }

      .gray-content {
        border: 1px solid #f0f0f0;
      }

      .group-content {
        border-radius: 16px;
        background: #fff;
        margin-bottom: 16px;
        &:last-child {
          margin-bottom: 0;
        }

        > .info {
          padding: 24px;
          .header {
            height: 40px;
            line-height: 40px;
            width: 100%;
            .label {
              float: left;
              color: #202945;
              font-weight: bold;
              font-size: 18px;
            }
            .tap {
              float: right;
              cursor: pointer;
              .text {
                float: left;
                color: #818181;
                font-size: 12px;
                font-weight: bold;
                margin-right: 3px;
              }
              .icon {
                float: left;
                color: #202945;
                font-weight: bold;
                font-size: 14px;
                transition: all 0.3s;
                transform: rotate(0deg);

                &.rotate {
                  transform: rotate(-180deg);
                }
              }
            }
          }

          .list {
            margin-top: 16px;
            .item {
              line-height: 21px;
              font-size: 14px;
              margin-bottom: 8px;
              overflow: hidden;
              &:last-child {
                margin-bottom: 0;
              }
              .label {
                color: #4d4d4d;
                float: left;
              }
              .value {
                overflow: hidden;
                padding-left: 16px;
                color: #1a1a1a;
              }
            }
          }

          .track-list {
            padding-left: 36px;
            margin-top: 42px;
            .item {
              padding-left: 24px;
              border-left: 1px solid #f5f5f5;
              position: relative;
              padding-bottom: 42px;

              &:first-child {
                .circle {
                  .inner {
                    background-color: #00a0d9;
                  }
                }
              }

              &:last-child {
                border-left: 1px solid #fff;
                padding-bottom: 0;
              }
              .circle {
                width: 16px;
                height: 16px;
                border-radius: 100%;
                background: #f5f5f5;
                position: absolute;
                top: -16px;
                left: -8px;
                .inner {
                  width: 8px;
                  height: 8px;
                  border-radius: 100%;
                  background: #b3b3b3;
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  margin: auto;
                }
              }
              .fl1 {
                position: absolute;
                left: 24px;
                color: #1a1a1a;
                font-weight: bold;
                line-height: 20px;
                top: -17px;
                font-size: 14px;
              }
              .fl2 {
                color: #4d4d4d;
                line-height: 18px;
                color: #4d4d4d;
                font-weight: bold;
                font-size: 12px;
                padding-top: 10px;
              }
              .fl3 {
                padding-top: 6px;
                color: #818181;
                font-size: 14px;
                line-height: 21px;
              }
            }
          }
        }
      }

      > .l {
        flex: 1;
        width: 0;

        .detail-list {
          overflow: hidden;
          > .item {
            margin-top: 24px;
            .title {
              color: #202945;
              font-weight: bold;
              font-size: 12px;
              line-height: 17px;
            }
            .item-content {
              margin-top: 16px;

              .device-info {
                border-radius: 8px;
                box-shadow: 0 0 0 1px #f5f5f5 inset;
                overflow: hidden;
                padding: 16px;

                .device-img {
                  width: 44px;
                  height: 44px;
                  float: left;
                }
                .arrow-content {
                  float: right;
                  height: 44px;
                  line-height: 44px;
                  .icon {
                    font-size: 16px;
                    font-weight: bold;
                  }
                }
                .device-params {
                  padding-left: 24px;
                  overflow: hidden;
                  .body-num {
                    margin-top: 1px;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: bold;
                    color: #1a1a1a;
                  }
                  .tag-list {
                    overflow: hidden;
                    color: #818181;
                    font-weight: bold;

                    font-size: 12px;
                    .product-code {
                      float: left;

                      line-height: 18px;
                      margin-right: 8px;
                      margin-top: 4px;
                    }
                    .tag {
                      margin-right: 8px;
                      padding: 0 6px;
                      border-radius: 9px;
                      text-align: center;
                      background-color: #f5f5f5;
                      margin-top: 4px;

                      line-height: 18px;
                      height: 18px;
                      float: left;
                      &:last-child {
                        margin-right: 0;
                      }
                    }
                  }
                }
              }

              .fault-info {
                .fault-desc {
                  color: #4d4d4d;
                  line-height: 20px;
                }
                .fault-img {
                  overflow: hidden;
                  margin-top: 16px;
                  .img-item {
                    float: left;
                    margin-right: 16px;
                    width: 64px;
                    height: 64px;
                    position: relative;
                    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05) inset;
                    border-radius: 8px;
                    &:last-child {
                      margin-right: 0;
                    }

                    .img {
                      position: absolute;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      top: 0;
                      margin: auto;
                      max-width: 100%;
                      max-height: 100%;
                    }
                  }
                }
              }

              .part-list {
                .part-item {
                  margin-bottom: 16px;
                  padding: 16px;
                  overflow: hidden;
                  box-shadow: 0 0 0 1px rgba(245, 245, 245, 1) inset;
                  border-radius: 8px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                  .part-img {
                    position: relative;
                    width: 44px;
                    height: 44px;
                    float: left;
                    border-radius: 8px;
                    overflow: hidden;

                    .img {
                      position: absolute;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      top: 0;
                      margin: auto;
                      max-width: 100%;
                      max-height: 100%;
                    }
                  }
                  .part-num {
                    float: right;
                    line-height: 44px;
                    color: #4d4d4d;
                    font-size: 14px;
                  }
                  .part-info {
                    overflow: hidden;
                    padding-left: 16px;
                    .part-name {
                      margin-top: 3px;
                      font-weight: bold;
                      line-height: 20px;
                      color: #1a1a1a;
                      font-size: 14px;
                    }
                    .part-params {
                      color: #818181;
                      font-size: 12px;
                      line-height: 18px;
                    }
                  }
                }
              }
            }
            .maintain-list {
              padding-top: 16px;

              .maintain-item {
                overflow: hidden;
                margin-top: 16px;
                padding-left: 20px;

                &__title {
                  color: #202945;
                  font-weight: bold;
                  font-size: 12px;
                  height: 17px;
                  line-height: 17px;
                }

                .img-list {
                  overflow: hidden;
                  margin-top: 16px;

                  .img-item {
                    width: 64px;
                    height: 64px;
                    float: left;
                    margin-right: 16px;
                    overflow: hidden;
                    border-radius: 8px;
                  }
                }
              }
            }
            .check-list {
              overflow: hidden;
              margin-top: 16px;
              .check-item {
                height: 20px;
                line-height: 20px;
                overflow: hidden;
                &:nth-child(n + 2) {
                  margin-top: 14px;
                }

                .item-text {
                  color: #4d4d4d;
                  font-size: 14px;
                  overflow: hidden;
                }

                .checked-content {
                  float: right;
                  width: 20px;
                  height: 20px;
                  margin-left: 8px;
                  background-size: 100%;
                  background-repeat: no-repeat;

                  &.checked {
                    background-image: url('~@/images/checked.png');
                  }
                }
              }
            }
            /deep/ {
              .el-tabs .el-tabs__item {
                font-size: 14px !important;
              }
              .el-tabs .el-tabs__header {
                margin-bottom: 0;
              }

              .el-collapse {
                border: none;
              }

              .el-collapse-item__wrap {
                border-bottom: none;
              }

              .el-collapse-item {
                &:nth-child(n + 2) {
                  margin-top: 14px;
                }
              }
              .el-collapse-item__header {
                font-size: 14px;
                line-height: 20px;
                height: 20px;
                border: none;
                // align-items: center;
              }
              .el-collapse-item__arrow {
                transform: rotate(90deg);
                color: #202945;
                position: relative;
                right: -7px;
                font-weight: bold;
              }
              .el-collapse-item__arrow.is-active {
                transform: rotate(-90deg);
              }
            }
          }
        }
      }
      > .r {
        width: 380px;
        margin-left: 24px;

        .repairman {
          height: 109px;
          .title {
            padding-left: 16px;
            color: #4d4d4d;
            font-size: 12px;
            line-height: 17px;
            margin-top: 16px;
            font-weight: bold;
          }
          .group {
            margin-top: 16px;
            overflow: hidden;
            .avatar {
              float: left;
              width: 44px;
              height: 44px;
              overflow: hidden;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
              margin-left: 16px;
            }
            .info {
              overflow: hidden;
              padding-left: 16px;
              .name {
                line-height: 20px;
                font-size: 14px;
                color: #1a1a1a;
                font-weight: bold;
                margin-top: 1px;
              }
              .company {
                margin-top: 4px;
                color: #4d4d4d;
                font-size: 12px;
                line-height: 18px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
